import { render, staticRenderFns } from "./AddPlatFormDialog.vue?vue&type=template&id=4fd77cce&scoped=true"
import script from "./AddPlatFormDialog.vue?vue&type=script&lang=js"
export * from "./AddPlatFormDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPlatFormDialog.vue?vue&type=style&index=0&id=4fd77cce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd77cce",
  null
  
)

export default component.exports